import { createAsyncThunk } from "@reduxjs/toolkit";
//Include Both Helper File with needed methods
import {
  getAuthList as getAuthListApi,
  getSummaryCards as getSummaryCardsApi,
  getCountryList as getCountryListApi,
  getCountryListInt2 as getCountryListInt2Api,
  getUserAddressInfos as getUserAddressInfosApi,
  getDocumentTypeList as getDocumentTypeListApi,
  getReferralLinkDetails as getReferralLinkDetailsApi,
  getRebateDetails as getRebateDetailsApi,
  addIBOnboardingPersonalInfo as addIBOnboardingPersonalInfoApi,
  addInvestIBOnboardingSMSReq as addInvestIBOnboardingSMSReqApi,
  addInvestIBOnboardingCodeReq as addInvestIBOnboardingCodeReqApi,
  addIBOnboardingBankInfo as addIBOnboardingBankInfoApi,
  addIBOnboardingIdentityVerify as addIBOnboardingIdentityVerifyApi,
  addIBOnboardingAddressVerify as addIBOnboardingAddressVerifyApi,
  getPartnerClients as getPartnerClientsApi,
  getPartnerTradingVolume as getPartnerTradingVolumeApi,
  getPartnerBalance as getPartnerBalanceApi,
  getPNLShareContractInfo as getPNLShareContractInfoApi,
  changePersonalPassword as changePersonalPasswordApi,
  getScaAccountInfoList as getScaAccountInfoListApi,
  getWalletAccountInfoList as getWalletAccountInfoListApi,
  getDepositRedirectParameter as getDepositRedirectParameterApi,
  addWithdrawalInfo as addWithdrawalInfoApi,
  addWithdrawalWalletInfo as addWithdrawalWalletInfoApi,
  addInternalTransferInfo as addInternalTransferInfoApi,
  getRequestedDocuments as getRequestedDocumentsApi,
  addRequestedDocuments as addRequestedDocumentsApi,
} from "../../helpers/ServiceHelpers/backend_helper";

// Get Auth User
export const getAuthList = createAsyncThunk("get/AuthList", async () => {
  try {
    const response = getAuthListApi();
    return response;
  } catch (error) {
    return error;
  }
});

// Get Summary Cards
export const getSummaryCards = createAsyncThunk(
  "get/SummaryCards",
  async (id: number) => {
    try {
      const response = getSummaryCardsApi(id);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Referral Link Details
export const getReferralLinkDetails = createAsyncThunk(
  "get/ReferralLinkDetails",
  async (id: number) => {
    try {
      const response = getReferralLinkDetailsApi(id);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Rebate Details
export const getRebateDetails = createAsyncThunk(
  "get/RebateDetails",
  async (id: number) => {
    try {
      const response = getRebateDetailsApi(id);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Post IB Onboarding Personal Info
export const addIBOnboardingPersonalInfo = createAsyncThunk(
  "post/IBOnboardingPersonalInfo",
  async (data: any) => {
    try {
      const response = addIBOnboardingPersonalInfoApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Post Invest IB Onboarding SMS Verification
export const addInvestIBOnboardingSMSReq = createAsyncThunk(
  "post/addInvestIBOnboardingSMSReq",
  async (data: any) => {
    try {
      const response = addInvestIBOnboardingSMSReqApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Post Invest IB Onboarding OTP Code Send
export const addInvestIBOnboardingCodeReq = createAsyncThunk(
  "post/addInvestIBOnboardingCodeReq",
  async ({ id, data }: { id: number; data: any }) => {
    try {
      const response = addInvestIBOnboardingCodeReqApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Post IB Onboarding Bank Info
export const addIBOnboardingBankInfo = createAsyncThunk(
  "post/IBOnboardingBankInfo",
  async ({ id, data }: { id: number; data: FormData }) => {
    try {
      const response = addIBOnboardingBankInfoApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Post IB Onboarding Identity Verification
export const addIBOnboardingIdentityVerify = createAsyncThunk(
  "post/IBOnboardingIdentityVerify",

  async ({ id, data }: { id: number; data: FormData }) => {
    try {
      const response = await addIBOnboardingIdentityVerifyApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Post IB Onboarding Address Verification
export const addIBOnboardingAddressVerify = createAsyncThunk(
  "post/IBOnboardingAddressVerify",

  async ({ id, data }: { id: number; data: FormData }) => {
    try {
      const response = await addIBOnboardingAddressVerifyApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Country List
export const getCountryList = createAsyncThunk("get/CountryList", async () => {
  try {
    const response = getCountryListApi();
    return response;
  } catch (error) {
    return error;
  }
});

// Get Country List Int2
export const getCountryListInt2 = createAsyncThunk(
  "get/CountryListInt2",
  async () => {
    try {
      const response = getCountryListInt2Api();
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Address Infos
export const getUserAddressInfos = createAsyncThunk(
  "get/AddressList",
  async () => {
    try {
      const response = getUserAddressInfosApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Document Type List
export const getDocumentTypeList = createAsyncThunk(
  "get/DocumentTypeList",
  async () => {
    try {
      const response = getDocumentTypeListApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Partner Clients
export const getPartnerClients = createAsyncThunk(
  "get/PartnerClients",
  async (id: number) => {
    try {
      const response = getPartnerClientsApi(id);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Partner Trading Volume
export const getPartnerTradingVolume = createAsyncThunk(
  "get/PartnerTradingVolume",
  async (id: number) => {
    try {
      const response = getPartnerTradingVolumeApi(id);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Partner Balance
export const getPartnerBalance = createAsyncThunk(
  "get/PartnerBalance",
  async (id: number) => {
    try {
      const response = getPartnerBalanceApi(id);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get PNL Share Contract Info
export const getPNLShareContractInfo = createAsyncThunk(
  "get/PNLShareContractInfo",
  async (id: number) => {
    try {
      const response = getPNLShareContractInfoApi(id);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// change Personal Password
export const changePersonalPassword = createAsyncThunk(
  "post/changePersonalPassword",
  async (data: any) => {
    try {
      const response = changePersonalPasswordApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Sca Account Info List
export const getScaAccountInfoList = createAsyncThunk(
  "get/getScaAccountInfoList",
  async () => {
    try {
      const response = getScaAccountInfoListApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Wallet Account Info List
export const getWalletAccountInfoList = createAsyncThunk(
  "get/getWalletAccountInfoList",
  async (id: any) => {
    try {
      const response = getWalletAccountInfoListApi(id);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Post Withdrawal Info
export const addWithdrawalInfo = createAsyncThunk(
  "post/addWithdrawalInfo",
  async (data: any) => {
    try {
      const response = addWithdrawalInfoApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Post Withdrawal Wallet Info
export const addWithdrawalWalletInfo = createAsyncThunk(
  "post/addWithdrawalWalletInfo",
  async (data: any) => {
    try {
      const response = addWithdrawalWalletInfoApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Post Internal Transfer Info
export const addInternalTransferInfo = createAsyncThunk(
  "post/addInternalTransferInfo",
  async (data: any) => {
    try {
      const response = addInternalTransferInfoApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Deposit Redirect Parameter
export const getDepositRedirectParameter = createAsyncThunk(
  "get/DepositRedirectParameter",
  async () => {
    try {
      const response = getDepositRedirectParameterApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const clearDepositRedirectParameter = createAsyncThunk(
  "dashboard/clearDepositRedirectParameter",
  async () => {
    return {};
  }
);

// Get Requested Documents
export const getRequestedDocuments = createAsyncThunk(
  "get/RequestedDocuments",
  async (data: any) => {
    try {
      const response = getRequestedDocumentsApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Post Requested Documents
export const addRequestedDocuments = createAsyncThunk(
  "post/RequestedDocuments",
  async ({ partnerId, data }: { partnerId: number; data: FormData }) => {
    try {
      const response = await addRequestedDocumentsApi(partnerId, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
